// extracted by mini-css-extract-plugin
export var statItem = "_j9-1";
export var statsRow = "_j9-0";